module.exports = __webpack_public_path__ + "media/images/front/about/icon_movielist-dea94d610b567aeae189d952d07946f2.png";